import React, { useEffect } from 'react';
// import Spinner from '../../components/shared/spinner';
// import api from '../../services/apiService'

import { UserManager, WebStorageStateStore } from 'oidc-client';
import { withRouter } from 'react-router-dom';
// import { useDispatch } from "react-redux";
// import getCompanies from '../../redux/actions/companies/getCompanies';
// import appLS from '../../constants/local-storage';

function SigninSilentCallback() {

  // { history }
  // const dispatch = useDispatch();

  useEffect(() => {
    new UserManager({
      userStore: new WebStorageStateStore({ store: localStorage })
    }).signinSilentCallback().catch(function (e) {
      console.error(e);
    });
  }, []);

  return <></>
}

export default withRouter(SigninSilentCallback);